const press = [
    { 'press': 'CDM: Mayss "On this Land"', 'link': 'https://cdm.link/mayss-on-this-land/' },
    {
        'press': 'DJ Mag top 2025 comps', 'link': 'https://djmag.com/features/dj-mags-top-compilations-of-2025'
    },

    {
        'press': 'RA Mix of the Day', 'link': 'https://ra.co/news/82987'
    },
    { 'press': 'DJ Mag covering Letters to the Sun', 'link': ' https://www.google.com/search?q=djmag+mayss+letters+to+the+sun&oq=djmag+mayss+letters+to+the+sun&gs_lcrp=EgZjaHJvbWUyCwgAEEUYChg5GKABMgkIARAhGAoYoAEyCQgCECEYChigATIJCAMQIRgKGKABMgcIBBAhGI8CMgcIBRAhGI8CMgcIBhAhGI8C0gEINDIwOWowajeoAgCwAgA&sourceid=chrome&ie=UTF-8' },
    { 'press': 'DJ Mag covering Enough!', 'link': 'https://djmag.com/news/nicolas-jaar-simo-cell-kmru-juliana-huxtable-more-contribute-62-track-compilation-gaza' },
    { 'press': 'The Quietus', 'link': 'https://thequietus.com/news/martin-rev-suzanne-ciani-and-more-contribute-music-to-compilation-for-palestine/' },
    { 'press': 'Electronic Groove', 'link': 'https://electronicgroove.com/nicolas-jaar-kmru-unite-compilation-for-palestinian-children/' },
    {
        'press': 'CDM: Enough! comp', 'link': 'https://cdm.link/enough-compilation-call-to-sound-from-dr-ghassan/'

    },
    {
        'press': 'RA', 'link': 'https://ra.co/news/82987'

    }
];

export default press;
